if (!customElements.get('kleengent-sticky-purchase')) {
  customElements.define('kleengent-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.kg-product-purchase');
      this.bar = this.querySelector('.kg-sticky-purchase__bar');
      this.form = this.section?.querySelector('product-form form.main-product-form');
      this.mainButton = this.form?.querySelector('[data-addtocart-main]');
      this.mainQuantity = this.section?.querySelector('[data-input-quantity]');
      this.stickyQuantity = this.querySelector('[data-sticky-quantity]');
      this.stickyButton = this.querySelector('[data-sticky-submit]');
      this.price = this.section?.querySelector('[data-main-price]');
      this.variant = this.section?.querySelector('[data-selected-variant]');
      if (!this.bar || !this.form || !this.mainButton) return;

      this.abort = new AbortController();
      const signal = this.abort.signal;
      window.addEventListener('scroll', () => this.queueSync(), { passive: true, signal });
      window.addEventListener('resize', () => this.queueSync(), { signal });
      this.section.addEventListener('change', () => this.queueSync(), { signal });
      this.section.addEventListener('input', () => this.queueSync(), { signal });
      this.stickyQuantity.addEventListener('change', () => this.updateQuantity(), { signal });
      this.stickyButton.addEventListener('click', () => this.submit(), { signal });
      this.observer = new MutationObserver(() => this.queueSync());
      this.observer.observe(this.mainButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
      if (this.price) this.observer.observe(this.price, { childList: true, characterData: true, subtree: true });
      if (this.variant) this.observer.observe(this.variant, { childList: true, characterData: true, subtree: true });
      this.drawer = document.querySelector('#minicart');
      if (this.drawer) this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
      this.observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      this.sync();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    queueSync() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.sync();
      });
    }

    updateQuantity() {
      if (!this.stickyQuantity.reportValidity()) return;
      if (this.mainQuantity) {
        this.mainQuantity.value = this.stickyQuantity.value;
        this.mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.queueSync();
    }

    submit() {
      if (!this.stickyQuantity.reportValidity() || this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true') return;
      this.updateQuantity();
      if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit(this.mainButton);
      else this.mainButton.click();
      this.queueSync();
    }

    sync() {
      if (!this.isConnected || !this.mainButton) return;
      if (this.mainQuantity) {
        for (const attribute of ['min', 'max', 'step']) {
          if (this.mainQuantity.hasAttribute(attribute)) this.stickyQuantity.setAttribute(attribute, this.mainQuantity.getAttribute(attribute));
          else this.stickyQuantity.removeAttribute(attribute);
        }
        if (document.activeElement !== this.stickyQuantity) this.stickyQuantity.value = this.mainQuantity.value;
      } else {
        this.querySelector('.kg-sticky-purchase__quantity').hidden = true;
      }
      const priceText = this.price?.querySelector('[data-product-actual-price]')?.textContent.trim();
      if (priceText) this.querySelector('[data-sticky-price]').textContent = priceText;
      if (this.variant) {
        try {
          const selected = JSON.parse(this.variant.textContent);
          this.querySelector('[data-sticky-variant]').textContent = selected?.title === 'Default Title' ? '' : (selected?.title || '');
        } catch { this.querySelector('[data-sticky-variant]').textContent = ''; }
      }
      const disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
      this.stickyButton.disabled = disabled;
      this.stickyButton.textContent = this.mainButton.querySelector('[data-addtocart-text]')?.textContent.trim() || this.mainButton.textContent.trim();
      const passed = this.mainButton.getClientRects().length > 0 && this.mainButton.getBoundingClientRect().bottom <= 0;
      const overlay = this.drawer?.classList.contains('active') || document.body.classList.contains('no-scroll') || !!document.querySelector('dialog[open]');
      this.bar.hidden = !passed || overlay;
    }
  });
}

